import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Search, MapPin, ArrowLeft, ShieldCheck } from "lucide-react";
import { BrandWordmark, BrandMark } from "@/components/BrandMark";

export const PublicSearch = () => {
  const [q, setQ] = useState("");
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);

  const doSearch = async (e) => {
    e?.preventDefault();
    if (q.length < 2) return;
    setBusy(true);
    try {
      const { data } = await api.get("/public/search", { params: { q } });
      setResult(data);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen p-6 lg:p-12">
      <div className="flex items-center justify-between mb-6">
        <BrandMark size={140} />
        <Link to="/portal" className="cad-btn-outline px-3 py-1.5 rounded-sm text-[12px] inline-flex items-center gap-1.5"><ArrowLeft size={12}/> Portal</Link>
      </div>
      <div className="cad-panel p-6">
        <div className="font-mono-cad text-[10px] uppercase tracking-[0.28em] text-[#C99A2E]">Public Cadastre Search</div>
        <h1 className="font-display text-3xl font-bold text-[#F6F8FA] mt-1">Find a parcel or mineral right</h1>
        <form onSubmit={doSearch} className="mt-5 flex gap-2">
          <div className="relative flex-1">
            <Search size={14} className="absolute left-3 top-3 text-[#7C93A5]" />
            <input value={q} onChange={(e) => setQ(e.target.value)} data-testid="public-search-input"
                   placeholder="Try ZW-HAR-01203, gold, Kariba, mining commissioner…"
                   className="w-full bg-[#071B2B] border cad-hairline rounded-sm pl-9 pr-3 py-3 text-[14px] text-[#F6F8FA] focus:ring-2 focus:ring-[#C99A2E] outline-none" />
          </div>
          <button data-testid="public-search-btn" className="cad-btn-primary px-5 rounded-sm text-sm">Search</button>
        </form>
        {busy && <div className="mt-6 text-[13px] text-[#B3C2CC]">Searching demonstration register…</div>}
      </div>

      {result && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
          <div className="cad-panel p-5">
            <div className="font-mono-cad text-[10px] uppercase tracking-[0.24em] text-[#7C93A5] mb-2">Parcels ({result.parcels.length})</div>
            <div className="space-y-2">
              {result.parcels.slice(0, 20).map((p) => (
                <div key={p.id} className="border-b cad-hairline pb-2 last:border-none">
                  <div className="flex items-center justify-between">
                    <div className="font-mono-cad text-[#F6F8FA]">{p.parcel_number}</div>
                    <span className="cad-chip capitalize">{(p.land_type || "").replace(/_/g, " ")}</span>
                  </div>
                  <div className="text-[12px] text-[#B3C2CC]">{p.district}, {p.province} · {p.area_ha} ha</div>
                  <Link to={`/verify/${p.parcel_number}`} className="text-[11px] text-[#C99A2E]">Verify certificate →</Link>
                </div>
              ))}
              {result.parcels.length === 0 && <div className="text-[12px] text-[#7C93A5]">No parcels match.</div>}
            </div>
          </div>
          <div className="cad-panel p-5">
            <div className="font-mono-cad text-[10px] uppercase tracking-[0.24em] text-[#7C93A5] mb-2">Mineral rights ({result.mineral_rights.length})</div>
            <div className="space-y-2">
              {result.mineral_rights.slice(0, 20).map((m) => (
                <div key={m.id} className="border-b cad-hairline pb-2 last:border-none">
                  <div className="flex items-center justify-between">
                    <div className="font-mono-cad text-[#F6F8FA]">{m.licence_number || m.application_number}</div>
                    <span className={`cad-chip ${m.status === "active" ? "cad-chip-green" : "cad-chip-blue"}`}>{m.status.replace(/_/g, " ")}</span>
                  </div>
                  <div className="text-[12px] text-[#B3C2CC]">{m.commodity} · {m.province} · {m.area_ha} ha</div>
                  <Link to={`/verify/${m.licence_number || m.application_number}`} className="text-[11px] text-[#C99A2E]">Verify certificate →</Link>
                </div>
              ))}
              {result.mineral_rights.length === 0 && <div className="text-[12px] text-[#7C93A5]">No mineral rights match.</div>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
